import axios from 'axios';
import {
  FETCH_CURRENT_REQUEST,
  FETCH_CURRENT_SUCCESS,
  FETCH_CURRENT_FAILED,
  SWITCH_TYPE,
} from './constants';
import config from '../config';

export const fetchCurrentDataSuccess = payload => ({
  type: FETCH_CURRENT_SUCCESS,
  payload,
})

export const fetchCurrentDataFailed = payload => ({
  type: FETCH_CURRENT_FAILED,
  payload,
})

export const fetchCurrentData = () => async (dispatch, getState) => {
  if (getState().data.pending) return;
  dispatch({
    type: FETCH_CURRENT_REQUEST,
  })
  try {
    const response = await axios.get('/.netlify/functions/get-weather?type=current');
    dispatch(fetchCurrentDataSuccess(response.data));
  }
  catch(e) {
    dispatch(fetchCurrentDataFailed(e));
  }
}

export const pollCurrentData = () => async dispatch => {
  dispatch(fetchCurrentData());
  setInterval(() => {
    dispatch(fetchCurrentData())
  }, config.pollInterval)
}

export const switchType = id => type => ({
  type: SWITCH_TYPE,
  meta: { id },
  payload: type,
})



// WEBPACK FOOTER //
// ./src/store/actions.js